<template>
  <div :class="{ cb_checkout_success_page: showCustomBlueSuccessPage }">
    <CustomBlueCheckoutSuccess
      v-if="showCustomBlueSuccessPage"
      layout="moblie"
      :repayment-data="repaymentData"
      :collection-data="collectionData"
      :country-info="countryInfo"
      :country-info-logo="countryInfoLogo"
      :format-bank-name="formatBankName"
    />
    <ThemePaymentAccountEntryPage
      v-else-if="showPaymentAccountEntryPage"
      v-model="paymentAccount"
      layout="moblie"
      :repayment-data="repaymentData"
      :country-info="countryInfo"
      :country-info-logo="countryInfoLogo"
      :operator-list="operatorList"
      :phone-max-length="phoneMaxLength"
      :payment-amount="formattedPaymentAmount"
      :show-operator-list="repaymentData.extraParams?.includes('customerBankCode')"
      @choose-operator="chooseOperator"
      @submit="onOpenPaymentAccountVerifyClick"
    />
    <ThemeCopyPayPage
      v-else-if="showThemeCopyPayPage"
      layout="moblie"
      :repayment-data="repaymentData"
      :collection-data="collectionData"
      :collection-data-step="collectionDataStep"
      :country-info="countryInfo"
      :country-info-logo="countryInfoLogo"
      :hr="hr"
      :min="min"
      :sec="sec"
      :formatted-payment-amount="formattedPaymentAmount"
      :transaction-id-template="transactionIdTemplate"
      :transaction-id="transactionId"
      :is-submit-transaction-id="isSubmitTransactionId"
      :refresh-num="refreshNum"
      :show-error="showError"
      :is-hide-textarea="isHideTextarea"
      :sms-placeholder="getInputPlaceholder()"
      :collection-show="collectionShow"
      :collection-detail-show="collectionDetailShow"
      :payment-account-verify-show="paymentAccountVerifyShow"
      :user-submit-account-number="userSubmitAccountNumber"
      :pop-commit-text="popCommitText"
      :format-bank-name="formatBankName"
      @update:transaction-id-template="transactionIdTemplate = $event"
      @copy="onCopy"
      @refresh="refresh"
      @submit-transaction="onTransactionIdSubmitClick"
      @show-detail="getCollectedDetail"
      @get-results="getResults"
      @close-collection="collectionShow = false"
      @close-collection-detail="collectionDetailShow = false"
      @return-payment-account="paymentAccountVerifyReturn"
      @confirm-payment-account="onPaymentAccountVerifySubmitClick"
    />
    <div v-else class="moblie_pay" :class="themeRootClass">
    <div
        class="moblie_pay_header"
        :style="isCustomBlueTheme ? themeBannerStyle : (themeBannerStyle || {
        background: `url(${
          repaymentData?.configData?.bannerFileUrl
            ? repaymentData.configData.bannerFileUrl
            : require('@/assets/banner.png')
        }) no-repeat`,
        backgroundSize: `100% 100%`,
      })"
    >
      <div v-if="isCustomBlueTheme" class="moblie_pay_header_cb">
        <img
            class="moblie_pay_header_cb_logo"
            :src="
              repaymentData?.configData?.logoFileUrl
                ? repaymentData.configData.logoFileUrl
                : countryInfoLogo
            "
            alt=""
        />
      </div>
      <div v-else class="moblie_pay_header_content">
        <div class="moblie_pay_header_img_box">
          <img
              class="moblie_pay_header_img"
              :src="
              repaymentData?.configData?.logoFileUrl
                ? repaymentData.configData.logoFileUrl
                : countryInfoLogo
            "
              alt=""
          />
          <!-- <div class="moblie_pay_header_text">WE Pay</div> -->
        </div>
        <!--        <div class="moblie_pay_header_time_repayment">Repayment</div>-->
        <div class="moblie_pay_header_time_box">
          <div class="moblie_pay_header_time_title">
            {{ $t('text_remaining_time') }}
          </div>
          <div class="moblie_pay_header_time_info">
            <div class="moblie_pay_header_time_item">
              <div class="moblie_pay_header_time" v-if="hr">
                <div class="moblie_pay_header_time_item">
                  {{ hr.toString()[0] }}
                </div>
                <div class="moblie_pay_header_time_item">
                  {{ hr.toString()[1] }}
                </div>
              </div>
              <div class="moblie_pay_header_text">:</div>
            </div>
            <div class="moblie_pay_header_time_item">
              <div class="moblie_pay_header_time" v-if="min">
                <div class="moblie_pay_header_time_item">
                  {{ min.toString()[0] }}
                </div>
                <div class="moblie_pay_header_time_item">
                  {{ min.toString()[1] }}
                </div>
              </div>
              <div class="moblie_pay_header_text">:</div>
            </div>
            <div class="moblie_pay_header_time_item">
              <div class="moblie_pay_header_time" v-if="sec">
                <div class="moblie_pay_header_time_item">
                  {{ sec.toString()[0] }}
                </div>
                <div class="moblie_pay_header_time_item">
                  {{ sec.toString()[1] }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isCustomBlueTheme" class="moblie_pay_hero">
      <p class="moblie_pay_hero_tagline">{{ checkoutPageTagline }}</p>
      <h1 class="moblie_pay_hero_title">{{ checkoutPageTitle }}</h1>
      <p class="moblie_pay_hero_subtitle">{{ checkoutPageSubtitle }}</p>
    </div>
    <div class="moblie_pay_box" :class="{ moblie_pay_box_cb: isCustomBlueTheme }">
      <div class="moblie_pay_container" :class="{ moblie_pay_container_cb: isCustomBlueTheme }">
        <div v-if="!isCustomBlueTheme" class="moblie_pay_container_step moblie_pay_container_step_card">
          <div class="moblie_pay_container_step_label">
            {{ $t('text_copy_pay') }}
          </div>
          <div class="moblie_pay_container_step_value">
            {{ $t('text_copy_this_bank_name1') }}
            <span v-if="formatBankName(repaymentData?.cardData?.bankName) != countryInfo?.enName"
                  class="moblie_pay_container_step_value_bn">{{
                formatBankName(repaymentData?.cardData?.bankName)
              }}</span>
            {{ $t('text_copy_this_bank_name2') }}
          </div>
        </div>
        <div class="moblie_pay_container_step_item_line">
          <div
              class="moblie_pay_container_step_item_box"
              :class="{ moblie_pay_checkout_card: isCustomBlueTheme }"
          >
            <div v-if="isCustomBlueTheme" class="moblie_pay_checkout_card_top">
              <div class="moblie_pay_checkout_card_top_amount">
                <div class="moblie_pay_checkout_card_top_label">{{ checkoutAmountLabel }}</div>
                <div class="moblie_pay_checkout_card_top_value">
                  <span>{{ countryInfo?.currencyCode }}</span>{{ repaymentData?.cardData?.amount }}
                </div>
              </div>
              <div class="moblie_pay_checkout_card_top_countdown">
                <div class="moblie_pay_checkout_card_top_label">{{ checkoutCountdownLabel }}</div>
                <div class="moblie_pay_checkout_card_top_timer">
                  <template v-if="hr">
                    <span class="moblie_pay_checkout_card_top_timer_item">{{ hr.toString().padStart(2, '0') }}</span>
                    <span class="moblie_pay_checkout_card_top_timer_sep">:</span>
                  </template>
                  <span v-if="min" class="moblie_pay_checkout_card_top_timer_item">{{ min.toString().padStart(2, '0') }}</span>
                  <span v-if="min || sec" class="moblie_pay_checkout_card_top_timer_sep">:</span>
                  <span v-if="sec" class="moblie_pay_checkout_card_top_timer_item">{{ sec.toString().padStart(2, '0') }}</span>
                </div>
              </div>
            </div>
            <template v-if="countryInfo?.enName === 'TH'">
              <div class="moblie_pay_container_step_item">
                <div class="moblie_pay_container_step_item_value">
                  <div style="font-size: 10px;" class="moblie_pay_container_step_item_value_label">
                    {{ $t('text_order_amount') }}:
                  </div>
                  <div class="moblie_pay_container_step_item_value_2">
                    <div style="font-size: 10px;color: #888888;" class="moblie_pay_container_step_item_value_2_info">
                      <span style="font-size: 10px;color: #888888;">{{ countryInfo?.currencyCode }}</span>
                      {{ repaymentData?.cardData?.amount }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="moblie_pay_container_step_item">
                <div class="moblie_pay_container_step_item_value">
                  <div class="moblie_pay_container_step_item_value_label">
                    <van-popover
                        v-model="showPopover"
                        theme="dark"
                        trigger="click"
                        placement="right-end"
                        class="moblie_pay_container_step_item_value_label_popover"
                    >
                      <div class="moblie_pay_container_step_item_value_label_popover_text">
                        {{ $t('text_please_use_payment') }}
                      </div>
                      <template #reference>
                        <van-icon class="moblie_pay_container_step_item_value_label_icon" name="warning-o"/>
                      </template>
                    </van-popover>
                    {{ $t('text_payment_amount') }}:
                  </div>
                  <div class="moblie_pay_container_step_item_value_2">
                    <div class="moblie_pay_container_step_item_value_2_info">
                      <span>{{ countryInfo?.currencyCode }}</span>
                      {{ repaymentData?.cardData?.discountedAmount }}
                    </div>
                    <img @click="onCopy(repaymentData?.cardData?.discountedAmount)"
                         class="moblie_pay_container_step_item_value_2_copy" src="@/assets/copy.png" alt="">
                  </div>
                </div>
              </div>
              <div
                  class="moblie_pay_container_step_item"
                  v-if="repaymentData?.cardData?.accountName"
              >
                <div class="moblie_pay_container_step_item_value">
                  <div class="moblie_pay_container_step_item_value_label">
                    {{ $t('text_account_name') }}:
                  </div>
                  <div class="moblie_pay_container_step_item_value_2">
                    <div class="moblie_pay_container_step_item_value_2_info">
                      {{ repaymentData?.cardData?.accountName }}
                    </div>
                    <img v-if="!['NE', 'MZ', 'SL', 'EG'].includes(countryInfo?.enName)" @click="onCopy(repaymentData?.cardData?.accountName)"
                         class="moblie_pay_container_step_item_value_2_copy" src="@/assets/copy.png" alt="">
                  </div>
                </div>
              </div>
              <div class="moblie_pay_container_step_item">
                <div class="moblie_pay_container_step_item_value">
                  <div class="moblie_pay_container_step_item_value_label">
                    {{ $t('text_bank_name') }}:
                  </div>
                  <div class="moblie_pay_container_step_item_value_2">
                    <div class="moblie_pay_container_step_item_value_2_info">
                      {{ repaymentData?.cardData?.bankAlias }}
                    </div>
                  </div>
                </div>
              </div>
              <div ref="accountStep" class="moblie_pay_container_step_item">
                <div class="moblie_pay_container_step_item_value">
                  <div class="moblie_pay_container_step_item_value_label">
                    <!--                    {{ formatBankName(repaymentData?.cardData?.bankName) }}-->
                    {{ $t('text_account') }}:
                  </div>
                  <div class="moblie_pay_container_step_item_value_2">
                    <div class="moblie_pay_container_step_item_value_2_info">
                      {{ repaymentData?.cardData?.accountNumber }}
                    </div>
                    <img @click="onCopy(repaymentData?.cardData?.accountNumber)"
                         class="moblie_pay_container_step_item_value_2_copy" src="@/assets/copy.png" alt="">
                    <!--                  <div-->
                    <!--                      class="moblie_pay_container_step_item_value_2_copy"-->
                    <!--                      @click="onCopy(repaymentData?.cardData?.accountNumber)"-->
                    <!--                  >-->
                    <!--                    {{ $t('text_copy') }}-->
                    <!--                  </div>-->
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div v-if="!isCustomBlueTheme" class="moblie_pay_container_step_item">
                <div class="moblie_pay_container_step_item_value">
                  <div class="moblie_pay_container_step_item_value_label">
                    {{ $t('text_total_amount') }}:
                  </div>
                  <div class="moblie_pay_container_step_item_value_2">
                    <div class="moblie_pay_container_step_item_value_2_info">
                      <span>{{ countryInfo?.currencyCode }}</span>
                      {{ repaymentData?.cardData?.amount }}
                    </div>
                    <img v-if="['NE', 'MZ', 'SL', 'EG'].includes(countryInfo?.enName)" @click="onCopy(repaymentData?.cardData?.amount)"
                         class="moblie_pay_container_step_item_value_2_copy" src="@/assets/copy.png" alt="">
                  </div>
                </div>
              </div>
              <div
                  v-if="isCustomBlueTheme"
                  class="moblie_pay_checkout_card_bottom"
              >
                <div
                    ref="accountStep"
                    class="moblie_pay_container_step_item moblie_pay_checkout_payee"
                >
                  <div class="moblie_pay_container_step_item_value">
                    <div class="moblie_pay_checkout_card_top_label moblie_pay_checkout_payee_label">
                      {{ checkoutPayeePrefix }} {{ formatBankName(repaymentData?.cardData?.bankName) }}
                    </div>
                    <div class="moblie_pay_container_step_item_value_2">
                      <div class="moblie_pay_container_step_item_value_2_info">
                        {{ repaymentData?.cardData?.accountNumber }}
                      </div>
                      <div
                          class="moblie_pay_checkout_copy"
                          @click="onCopy(repaymentData?.cardData?.accountNumber)"
                      >
                        {{ checkoutCopyLabel }} →
                      </div>
                    </div>
                  </div>
                </div>
                <div
                    class="moblie_pay_container_step_item moblie_pay_checkout_holder"
                    v-if="repaymentData?.cardData?.accountName"
                >
                  <div class="moblie_pay_container_step_item_value">
                    <div class="moblie_pay_checkout_card_top_label moblie_pay_checkout_holder_label">
                      {{ checkoutAccountHolderLabel }}
                    </div>
                    <div class="moblie_pay_container_step_item_value_2">
                      <div class="moblie_pay_container_step_item_value_2_info">
                        {{ repaymentData?.cardData?.accountName }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <template v-else>
                <div
                    ref="accountStep"
                    class="moblie_pay_container_step_item"
                >
                  <div class="moblie_pay_container_step_item_value">
                    <div class="moblie_pay_container_step_item_value_label">
                      {{ formatBankName(repaymentData?.cardData?.bankName) }}
                      {{ $t('text_account') }}:
                    </div>
                    <div class="moblie_pay_container_step_item_value_2">
                      <div class="moblie_pay_container_step_item_value_2_info">
                        {{ repaymentData?.cardData?.accountNumber }}
                      </div>
                      <img
                          @click="onCopy(repaymentData?.cardData?.accountNumber)"
                          class="moblie_pay_container_step_item_value_2_copy"
                          src="@/assets/copy.png"
                          alt=""
                      />
                    </div>
                  </div>
                </div>
                <div
                    class="moblie_pay_container_step_item"
                    v-if="repaymentData?.cardData?.accountName"
                >
                  <div class="moblie_pay_container_step_item_value">
                    <div class="moblie_pay_container_step_item_value_label">
                      {{ $t('text_account_name') }}:
                    </div>
                    <div class="moblie_pay_container_step_item_value_2">
                      <div class="moblie_pay_container_step_item_value_2_info">
                        {{ repaymentData?.cardData?.accountName }}
                      </div>
                      <img v-if="!['NE', 'MZ', 'SL', 'EG'].includes(countryInfo?.enName)" @click="onCopy(repaymentData?.cardData?.accountName)"
                           class="moblie_pay_container_step_item_value_2_copy" src="@/assets/copy.png" alt="">
                    </div>
                  </div>
                </div>
              </template>
            </template>
            <div
                class="moblie_pay_container_step_item"
                v-if="repaymentData?.cardData?.agentAccountId"
            >
              <div class="moblie_pay_container_step_item_value">
                <div class="moblie_pay_container_step_item_value_label">
                  {{ $t('text_agent_id') }}:
                </div>
                <div class="moblie_pay_container_step_item_value_2">
                  <div class="moblie_pay_container_step_item_value_2_info">
                    {{ repaymentData?.cardData?.agentAccountId }}
                  </div>
                  <img @click="onCopy(repaymentData?.cardData?.agentAccountId)"
                       class="moblie_pay_container_step_item_value_2_copy" src="@/assets/copy.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <div v-if="repaymentData?.cardData?.cmdCode" @click="onDial" class="moblie_pay_container_dial">
            {{ $t('text_click_pay') }}
          </div>
          <div v-if="repaymentData?.cardData?.cmdCode" class="moblie_pay_container_dial_text">
            {{ getDial() }}
            <img @click="onCopy(getDial())" class="moblie_pay_container_dial_text_img" src="@/assets/copy.png" alt="">
          </div>
        </div>
        <div class="moblie_pay_container_step moblie_pay_container_step_refresh">
          <div class="moblie_pay_container_step_label">
            {{ $t('text_payment_completed') }}
          </div>
          <div
              v-if="collectionDataStep==0"
              class="moblie_pay_container_step_value"
          >
            {{ $t('text_click') }}
            <span class="moblie_pay_container_step_value_bn">"{{ $t('text_refresh') }}"</span>
            {{ $t('text_check_successful') }}
          </div>
          <div
              v-if="collectionDataStep==1"
              class="moblie_pay_container_step_value"
          >
            {{ $t('text_check_successful2') }}
          </div>
        </div>
        <div class="moblie_pay_container_step_item_line">
          <div class="moblie_pay_container_step_item_box">
            <div ref="refreshStep" class="moblie_pay_container_step_account_box">
              <div class="moblie_pay_container_step_account_label">
                {{ $t('text_amount_paid') }}:
              </div>
              <div class="moblie_pay_container_step_account_box_2">
                <div class="moblie_pay_container_step_account_label_2">
                  <span v-if="collectionDataStep==0">
                    <span style="font-size: 14px;">{{ countryInfo?.currencyCode }}</span> {{
                      collectionData.collectedAmount
                    }}
                  </span>
                  <span v-if="collectionDataStep==1" style="color: #E68608;">
                    <span style="font-size: 14px;">{{ countryInfo?.currencyCode }}</span> {{
                      collectionData.collectedAmount
                    }}
                  </span>
                </div>
                <div @click="refresh" v-if="collectionDataStep==0" class="moblie_pay_container_step_account_label_3">
                  {{ $t('text_refresh') }}
                </div>
                <img v-if="collectionDataStep==1" class="moblie_pay_container_step_account_label_4"
                     src="@/assets/1119/success.png" alt="">
              </div>
              <div v-if="collectionDataStep==0" class="moblie_pay_container_step_account_box_3">
                {{ $t('text_expected_payment') }}
              </div>
            </div>
            <!-- <div v-if="refreshNum == 1 || showError" class="moblie_pay_container_step_account_box_6"> -->
              <!-- {{ $t('text_please_try_again2') }} -->
            <!-- </div> -->
            <template v-if="!isHideTextarea && (refreshNum != 0 || transactionId)">
              <div class="moblie_pay_container_step_account_box_4">
                {{ $t('text_get_results_faster') }}
              </div>
              <div class="moblie_pay_container_step_account_box_5">
                {{ $t('text_fill_payment') }}
              </div>
              <div class="moblie_pay_container_step_account">
                <!-- <div class="moblie_pay_container_step_account_input_desc">
                  After payment, please enter the Transaction ID
                </div> -->
                <div
                    v-if="!isSubmitTransactionId"
                    class="moblie_pay_container_step_account_input_box moblie_pay_container_step_account_input_box2"
                >
                <textarea
                    style="resize: none"
                    v-model="transactionIdTemplate"
                    class="moblie_pay_container_step_account_input"
                    type="textarea"
                    :placeholder="getInputPlaceholder()"
                />
                </div>
                <div class="moblie_pay_container_step_account_submit_box">
                  <div
                      v-if="!isSubmitTransactionId"
                      class="moblie_pay_container_step_sms_example_desc"
                  >
                    <span>*</span>{{ $t('text_fill_wrong_payment') }}
                  </div>
                  <div
                      v-if="!isSubmitTransactionId"
                      @click="onTransactionIdSubmitClick"
                      class="moblie_pay_container_step_account_submit moblie_pay_container_step_account_submit3"
                  >
                    <div class="moblie_pay_container_step_account_submit_text">
                      {{ $t('text_submit') }}
                    </div>
                    <img
                        class="moblie_pay_container_step_account_submit_text_img"
                        src="@/assets/1119/arrow.png"
                        alt=""
                    />

                    <!--            <img class="moblie_pay_container_step_account_submit_img" src="@/assets/submit.png"-->
                    <!--                 alt="">-->
                  </div>
                </div>
              </div>

              <template v-if="isSubmitTransactionId">
                <div class="moblie_pay_container_step_account">
                  <div class="moblie_pay_container_step_account_input_box moblie_pay_container_step_account_input_box2">
                <textarea
                    style="resize: none;border-radius: 8px;"
                    v-model="transactionIdTemplate"
                    class="moblie_pay_container_step_account_input"
                    type="textarea"
                    readonly
                />
                  </div>
                </div>
                <div class="moblie_pay_container_step_account_box_5">
                  {{ $t('text_transaction_id') }}:
                </div>
                <div class="moblie_pay_container_step_account">
                  <div
                      class="moblie_pay_container_step_account_input_box moblie_pay_container_step_account_input_box2 moblie_pay_container_step_account_input_box_s">
                <textarea
                    style="resize: none;color: #E68608;border-radius: 8px;"
                    v-model="transactionId"
                    class="moblie_pay_container_step_account_input"
                    type="textarea"
                    readonly
                />
                  </div>
                </div>
              </template>
            </template>
          </div>
          <!-- <div class="moblie_pay_container_step_sms_example">Payment SMS Example:</div>
          <div class="moblie_pay_container_step_sms_example_content">
            <div class="moblie_pay_container_step_sms_example_content_copy">Copy</div>
            <span>SKI77YS5EC</span> Confirmed. Ksh100.00 sent to XXX XXX 01xxxxxx17 on 18/11/24 at 10:26 AM.
          </div> -->
        </div>

        <div v-if="!['TH'].includes(countryInfo?.enName)"
             class="moblie_pay_container_step moblie_pay_container_step_box_account"
             :class="{ moblie_pay_container_step_box_account_cb: isCustomBlueTheme }"
        >
          <div class="moblie_pay_container_step_label">
            <template v-if="isCustomBlueTheme">{{ checkoutAccountSectionLabel }}</template>
            <template v-else>{{ $t('text_your_payment_account') }}:</template>
          </div>
          <div v-if="isCustomBlueTheme" class="moblie_pay_wallet_cb_card">
            <div class="moblie_pay_wallet_cb_label">{{ checkoutWalletLabel }}</div>
            <div class="moblie_pay_container_step_accountnumber moblie_pay_wallet_cb_value">
              {{ repaymentData?.cardData?.userSubmitAccountNumber }}
            </div>
          </div>
          <div
            v-if="isCustomBlueTheme && collectionDataStep == 0"
            class="moblie_pay_wallet_cb_confirm_btn"
            @click="refresh"
          >
            {{ paymentAccountPopupSubmitText }}
          </div>
        </div>
        <div v-if="!['TH'].includes(countryInfo?.enName) && repaymentData?.cardData?.tipsContent && !isCustomBlueTheme"
             class="moblie_pay_container_step_item_line">
          <div class="moblie_pay_container_step_item_box">
            <div class="moblie_pay_container_step_accountnumber">
              {{ repaymentData?.cardData?.userSubmitAccountNumber }}
            </div>
          </div>
        </div>
        <div v-if="!['TH'].includes(countryInfo?.enName) && !repaymentData?.cardData?.tipsContent && !isCustomBlueTheme">
          <div class="moblie_pay_container_step_accountnumber">
            {{ repaymentData?.cardData?.userSubmitAccountNumber }}
          </div>
        </div>
        <div v-if="repaymentData?.cardData?.tipsContent && !isCustomBlueTheme"
             class="moblie_pay_container_step moblie_pay_container_step_box_tipsContent">
          <div class="moblie_pay_container_step_label">
            {{ $t('text_payment_reminder') }}
          </div>
          <div class="moblie_pay_container_step_value moblie_pay_container_step_item_box" v-html="processedTipsContent">
          </div>
        </div>
      </div>

      <div v-if="isSubmitTransactionId" class="moblie_pay_container_result">
        <div class="moblie_pay_container_result_info">
          {{ $t('text_amount_received') }}:
          <div class="moblie_pay_container_result_info_content">
            <span>{{ countryInfo?.currencyCode }}</span>
            <span class="moblie_pay_container_result_info_amount">{{
                repaymentData?.cardData?.collectedAmount
                    ? repaymentData?.cardData?.collectedAmount
                    : 0
              }}</span>
            <div
                class="moblie_pay_container_result_info_btn"
                @click="getCollectedDetail"
            >
              {{ $t('text_details') }}
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="isSubmitTransactionId"
          @click="getResults"
          class="moblie_pay_container_result_submit"
      >
        <div class="moblie_pay_container_result_submit_text">{{ $t('text_get_details') }}</div>
        <img
            class="moblie_pay_container_result_submit_img"
            src="@/assets/1119/submit.png"
            alt=""
        />
      </div>
      <div v-if="isSubmitTransactionId" class="moblie_pay_container_tips">
        <img
            class="moblie_pay_container_tips_img"
            src="@/assets/1119/tips.png"
            alt=""
        />
        {{ $t('text_click_result_transfer') }}
      </div>
    </div>

    <!--    付款账号-->
    <van-popup get-container="body" v-model="paymentAccountShow"
               :safe-area-inset-bottom="true" :close-on-click-overlay="false">
      <div class="moblie_pay_payment_account_popup">
        <div class="moblie_pay_payment_account_popup_main">
          <div v-if="!isCustomBlueTheme" class="moblie_pay_payment_account_popup_main_logo">
            <img
                class="moblie_pay_payment_account_popup_main_logo_img"
                :src="
                repaymentData?.configData?.logoFileUrl
                  ? repaymentData.configData.logoFileUrl
                  : countryInfoLogo
              "
                alt=""
            />
          </div>
          <div class="moblie_pay_payment_account_popup_main_title">
            {{ paymentAccountPopupTitle }}
          </div>
          <!-- <div class="moblie_pay_payment_account_popup_main_desc">
            Enter your actual payment account to complete the payment.
          </div> -->
          <div class="moblie_pay_payment_account_popup_main_wait_amount">
            {{ $t('text_payment_amount') }}:<span>{{ countryInfo?.currencyCode }}</span>
            <span
                class="moblie_pay_payment_account_popup_main_wait_amount_num"
            >{{ formattedPaymentAmount }}</span
            >
          </div>
          <div class="paymentMethod" v-if="repaymentData.extraParams.includes('customerBankCode')">
            <div class="paymentMethod_title">{{ $t('text_please_select_payment_method') }}</div>
            <div class="paymentMethod_box">
              <div class="paymentMethod_item" :class="item.isSelect && 'paymentMethod_item_s'"
                   v-for="(item,index) in operatorList" @click="chooseOperator(index)" :key="index">
                <img class="paymentMethod_item_logo" :src="item.logo" alt="">
                <div class="paymentMethod_item_name">{{ item.name }}</div>

                <img v-if="item.isSelect" class="paymentMethod_item_true" :src="paymentMethodSelectedImg" alt="">
              </div>
            </div>
          </div>
          <div v-if="repaymentData.extraParams.includes('customerAccountNumber')"
               class="moblie_pay_container_step_account">
            <div class="moblie_pay_container_step_account_input_box">
              <div class="moblie_pay_container_step_233">+{{ countryInfo?.phoneCode }}</div>
              <input
                  v-model="paymentAccount"
                  class="moblie_pay_container_step_account_input"
                  type="text"
                  :maxlength="phoneMaxLength"
                  :placeholder="paymentAccountPopupInputPlaceholder"
              />
            </div>
          </div>
          <div class="moblie_pay_container_step_pay_account">
            <img
                v-if="showPaymentAccountPopupWarningIcon"
                class="moblie_pay_container_step_pay_account_img"
                src="@/assets/cardPay_NG/danger.png"
                alt=""
            />
            <template v-if="paymentAccountPopupWarning">{{ paymentAccountPopupWarning }}</template>
            <template v-else>
              {{ $t('text_please_fill_your_payment') }}
              <br/>
              {{ $t('text_please_fill_your_payment2') }}
            </template>
          </div>
          <div
              @click="onOpenPaymentAccountVerifyClick"
              class="moblie_pay_container_step_account_submit"
          >
            <div class="moblie_pay_container_step_account_submit_text">
              {{ paymentAccountPopupSubmitText }}
            </div>
            <img
                class="moblie_pay_container_step_account_submit_img"
                src="@/assets/cardPay_GH/submit.png"
                alt=""
            />
          </div>
          <div style="height: 20px"></div>
        </div>
      </div>
    </van-popup>

    <!--    transactionId二次确认-->
    <van-popup get-container="body"
               v-model="transactionIdTemplateShow"
               :safe-area-inset-bottom="true"
               :close-on-click-overlay="false"
    >
      <div class="moblie_pay_payment_account_popup">
        <div class="moblie_pay_payment_account_popup_main">
          <img
              @click="transactionIdTemplateShow = false"
              class="moblie_pay_payment_account_popup_main_close"
              src="@/assets/1231/close.png"
              alt=""
          />
          <div class="moblie_pay_payment_account_popup_main_logo">
            <img
                class="moblie_pay_payment_account_popup_main_logo_img"
                src="@/assets/1231/sms.png"
                alt=""
            />
          </div>
          <div class="moblie_pay_payment_account_popup_main_title">
            {{ $t('text_payment_sms') }}:
          </div>
          <div class="moblie_pay_payment_account_popup_main_desc">
            {{ transactionIdTemplate }}
          </div>
          <!-- <div class="moblie_pay_payment_account_popup_main_desc">
            Enter your actual payment account to complete the payment.
          </div> -->
          <div class="moblie_pay_payment_account_popup_main_wait_amount">
            {{ $t('text_transaction_id') }}:
          </div>
          <div class="moblie_pay_container_step_account">
            <div class="moblie_pay_container_step_account_input_box">
              <input
                  v-model="transactionId"
                  class="moblie_pay_container_step_account_input"
                  type="text"
                  :placeholder="$t('text_fill_payment')"
              />
            </div>
          </div>
          <div
              @click="onTransactionIdSubmitTwoClick"
              class="moblie_pay_container_step_account_submit moblie_pay_container_step_account_submit2"
          >
            <div class="moblie_pay_container_step_account_submit_text">
              {{ $t('text_confirm') }}
            </div>
          </div>
          <div style="height: 20px"></div>
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body"
               v-model="paymentAccountVerifyShow"
               :safe-area-inset-bottom="true"
               :close-on-click-overlay="false"
    >
      <div class="moblie_pay_payment_account_verify_popup">
        <div class="moblie_pay_payment_account_verify_popup_main">
          <div class="moblie_pay_payment_account_verify_popup_main_title">
            {{ $t('text_please_confirm_will_following_account_transfer') }}
          </div>
          <!-- <div class="moblie_pay_payment_account_verify_popup_main_item">
            <div class="moblie_pay_payment_account_verify_popup_main_item_label">votre mode de paiement:</div>
            <div class="moblie_pay_payment_account_verify_popup_main_item_value">{{ userSubmitOperator }}</div>
          </div> -->
          <div class="moblie_pay_payment_account_verify_popup_main_item">
            <div
                class="moblie_pay_payment_account_verify_popup_main_item_label"
            >
              {{ $t('text_your_payment_account') }}:
            </div>
            <div
                class="moblie_pay_payment_account_verify_popup_main_item_value"
            >
              {{ userSubmitAccountNumber }}
            </div>
          </div>
          <div class="moblie_pay_payment_account_verify_popup_main_btnBox">
            <div
                class="moblie_pay_payment_account_verify_popup_main_btn"
                @click="paymentAccountVerifyReturn"
            >
              {{ $t('text_return') }}
            </div>
            <div
                class="moblie_pay_payment_account_verify_popup_main_btn moblie_pay_payment_account_verify_popup_main_btn2"
                :class="
                timerOut != 3 &&
                'moblie_pay_payment_account_verify_popup_main_btn2_ban'
              "
                @click="onPaymentAccountVerifySubmitClick"
            >
              {{ popCommitText }}
            </div>
          </div>
          <!--          <div style="height: 20px;"></div>-->
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body"
               :safe-area-inset-bottom="true" v-model="editAccountShow">
      <div class="moblie_pay_payment_account_popup">
        <div class="moblie_pay_payment_account_popup_main">
          <div class="moblie_pay_payment_account_popup_main_title">
            Modify Payment Account
          </div>
          <div class="moblie_pay_payment_account_popup_main_cur_account">
            Current account:<span>{{
              repaymentData?.paymentData?.userSubmitAccountNumber
            }}</span>
          </div>
          <div class="moblie_pay_container_step_account">
            <div class="moblie_pay_container_step_account_input_box">
              <div class="moblie_pay_container_step_233">+{{ countryInfo?.phoneCode }}</div>
              <input
                  v-model="editAccountNumber"
                  class="moblie_pay_container_step_account_input"
                  type="text"
                  maxlength="10"
                  :placeholder="$t('text_please_enter_your_actual_payment_account')"
              />
            </div>
          </div>
          <div
              @click="editAccountSubmit"
              class="moblie_pay_container_step_account_submit"
          >
            <div class="moblie_pay_container_step_account_submit_text">
              {{ $t('text_confirm') }}
            </div>
            <img
                class="moblie_pay_container_step_account_submit_img"
                src="@/assets/cardPay_GH/submit.png"
                alt=""
            />
          </div>
          <div style="height: 30px"></div>
        </div>
        <div class="moblie_pay_payment_account_popup_close_box">
          <img
              class="moblie_pay_payment_account_popup_close"
              @click="editAccountShow = false"
              src="@/assets/cardPay_GH/close.png"
          />
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body"
               :safe-area-inset-bottom="true" v-model="editAccountConfirmShow">
      <div class="moblie_pay_payment_account_popup">
        <div class="moblie_pay_payment_account_popup_main">
          <div class="moblie_pay_payment_account_popup_main_title">
            <img
                class="moblie_pay_payment_account_popup_main_title_img"
                src="@/assets/cardPay_NG/danger.png"
                alt=""
            />
            Remind
          </div>
          <div
              class="moblie_pay_payment_account_popup_main_collect_confirm_box"
          >
            The payment account can only be changed once, are you sure you want
            to change it to <span>{{ editAccountNumber }}</span
          >?
          </div>
          <div class="moblie_pay_payment_account_popup_main_confirm_box">
            <div
                @click="onSubmitEditTrxNoClick"
                class="moblie_pay_container_step_account_submit"
            >
              <div class="moblie_pay_container_step_account_submit_text">
                {{ $t('text_confirm') }}
              </div>
              <img
                  class="moblie_pay_container_step_account_submit_img"
                  src="@/assets/cardPay_GH/submit.png"
                  alt=""
              />
            </div>
          </div>
          <div style="height: 30px"></div>
        </div>
        <div class="moblie_pay_payment_account_popup_close_box">
          <img
              class="moblie_pay_payment_account_popup_close"
              @click="editAccountConfirmShow = false"
              src="@/assets/cardPay_GH/close.png"
          />
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body"
               :safe-area-inset-bottom="true" v-model="collectionShow">
      <div class="moblie_pay_payment_account_popup">
        <div
            class="moblie_pay_payment_account_popup_main"
            v-if="collectionDataStep == 0"
        >
          <div class="moblie_pay_payment_account_popup_main_title">
            <img
                class="moblie_pay_payment_account_popup_main_title_img"
                src="@/assets/cardPay_NG/danger.png"
                alt=""
            />
            No payment received
          </div>
          <div class="moblie_pay_payment_account_popup_main_collect_box">
            <div class="moblie_pay_payment_account_popup_main_collect_num">
              Please check whether your payment account and actual payment
              amount are correct.
            </div>
            <div class="moblie_pay_payment_account_popup_main_collect_total">
              Payment account:<span>
                <!-- {{
                repaymentData?.paymentData?.userSubmitAccountNumber
              }} -->
                {{ repaymentData?.cardData?.accountNumber }}</span
            >
            </div>
          </div>
          <div style="height: 35px"></div>
        </div>
        <div
            class="moblie_pay_payment_account_popup_main"
            v-if="collectionDataStep == 1"
        >
          <div class="moblie_pay_payment_account_popup_main_title">
            Get results
          </div>
          <div class="moblie_pay_payment_account_popup_main_collect_box">
            <div class="moblie_pay_payment_account_popup_main_collect_num">
              {{ collectionData.transactionNums }} transfer received
            </div>
            <div class="moblie_pay_payment_account_popup_main_collect_total">
              Total amount:<span>{{ countryInfo?.currencyCode }} </span
            ><span
                class="moblie_pay_payment_account_popup_main_collect_total_amount"
            >{{ collectionData.collectedAmount }}</span
            >
              <div
                  @click="collectionDetailShow = true"
                  class="moblie_pay_payment_account_popup_main_collect_total_detail"
              >
                Detail
              </div>
            </div>
          </div>
          <div style="height: 35px"></div>
        </div>
        <div class="moblie_pay_payment_account_popup_close_box">
          <img
              class="moblie_pay_payment_account_popup_close"
              @click="collectionShow = false"
              src="@/assets/cardPay_GH/close.png"
          />
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body"
               :safe-area-inset-bottom="true" v-model="collectionDetailShow">
      <div class="moblie_pay_payment_account_popup">
        <div class="moblie_pay_payment_account_popup_main">
          <div
              class="moblie_pay_payment_account_popup_main_title moblie_pay_payment_account_popup_main_detail_title"
          >
            {{ $t('text_collection_details') }}
          </div>
          <div class="data-box">
            <van-row class="th-row">
              <van-col>{{ $t('text_order_number') }}</van-col>
              <van-col>{{ $t('text_debit_account') }}</van-col>
              <van-col>{{ $t('text_remittance_amount') }}</van-col>
              <van-col>{{ $t('text_payment_time') }}</van-col>
            </van-row>

            <van-row
                class="td-row"
                :style="{ background: index % 2 == 0 ? '#fff' : '#f1f1f1' }"
                v-for="(item, index) in collectionData.collectDetails"
                :key="index"
            >
              <van-col class="common-ellipsis"
              >{{ item.bankTransactionReference }}
              </van-col>
              <van-col class="common-ellipsis"
              >{{ item.destinationAccountNumber }}
              </van-col>
              <van-col class="common-ellipsis">{{ item.amount }}</van-col>
              <van-col class="common-ellipsis"
              >{{ item.transactionTime }}
              </van-col>
            </van-row>
          </div>
          <div style="height: 20px"></div>
        </div>
        <div class="moblie_pay_payment_account_popup_close_box">
          <img
              class="moblie_pay_payment_account_popup_close"
              @click="collectionDetailShow = false"
              src="@/assets/cardPay_GH/close.png"
          />
        </div>
      </div>
    </van-popup>

    </div>
    <FloatBall v-if="isShowBall && !showCustomBlueSuccessPage">
      <!-- 自定义悬浮球内容 -->
      <img v-if="floatBallImg" @click.stop="handleBallClick" @dragstart.prevent style="width: 100%;height: 100%;" :src="floatBallImg"
           alt="">
      <button v-else type="button" class="float-ball-text" @click.stop="handleBallClick">
        {{ floatBallText }}
      </button>
    </FloatBall>
  </div>
</template>

<script>
import indexJs from "./index.js";

export default {
  name: "Moblie",
  mixins: [indexJs],
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";

.moblie_pay {
  position: relative;
  // height: 100%;
  // min-height: 100vh;
  background-color: #f5f5f5;

  .moblie_pay_header {
    width: 100%;
    height: 150px;
    padding-bottom: 16px;
    box-sizing: border-box;
    // background: url("~@/assets/cardPay_GH/header.png") no-repeat;
    background-size: 100% 100%;

    .moblie_pay_header_content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      width: 100%;
      height: 68px;
      background: rgba(0, 0, 0, 0.3);

      .moblie_pay_header_img_box {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 20px;
        min-width: 50px;

        .moblie_pay_header_img {
          // width: 22px;
          height: 40px;
          border-radius: 8px;
          margin-right: 5px;
        }

        .moblie_pay_header_text {
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #404141;

          span {
            color: #f03024;
            margin-left: 10px;
          }
        }
      }

      .moblie_pay_header_time_repayment {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }

      .moblie_pay_header_time_box {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: wrap;

        .moblie_pay_header_time_title {
          width: 150px;
          height: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 10px;
          color: #e5e5e5;

          background: url("~@/assets/cardPay_GH/tansaction.png") no-repeat;
          background-size: 100% 100%;

          display: flex;
          align-items: center;
          justify-content: center;
        }

        .moblie_pay_header_time_info {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-top: 8px;
          // margin-left: 15px;
          width: 100%;

          .moblie_pay_header_time_item {
            position: relative;
            background-size: 100% 100%;
            margin-right: 2px;
            display: flex;
            align-items: center;

            .moblie_pay_header_time {
              font-family: LucidaGrande;
              font-size: 11px;
              color: #eeeeee;

              display: flex;
              align-items: center;

              .moblie_pay_header_time_item {
                width: 11px;
                height: 14px;
                background: rgba(255, 255, 255, 0.15);
                border-radius: 2px;
                border: 1px solid rgba(255, 255, 255, 0.5);

                display: flex;
                align-items: center;
                justify-content: center;
              }
            }

            .moblie_pay_header_text {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 9px;
              color: #e5e5e5;
              margin: 0 5px;
            }
          }

          .moblie_pay_header_time_left {
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #e5e5e5;

            margin-right: 5px;
          }
        }
      }
    }
  }

  .moblie_pay_box {
    transform: translateY(-68px);
    margin: 5px auto;
    width: calc(100% - 20px);
    background: #ffffff;
    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 15px;
    box-sizing: border-box;
    padding-bottom: 25px;
  }

  .moblie_pay_container {
    padding-top: 20px;
    margin-bottom: 8px;
    padding-left: 50px;
    padding-right: 15px;

    .moblie_pay_container_step {
      // display: flex;
      // align-items: flex-start;
      margin-bottom: 5px;
      // padding: 0 20px;
      &:nth-child(n + 2) {
        margin-top: 16px;
      }

      .moblie_pay_container_step_label {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
      }

      .moblie_pay_container_step_accountnumber {
        margin-top: 2px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #E68608;
      }

      .moblie_pay_container_step_value {
        flex: 1;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 11px;
        color: #8d8d8d;
        margin-top: 2px;
        word-wrap: break-word;
        word-break: break-all;
        overflow-wrap: break-word;
        white-space: normal;

        span {
          color: #e72e2e;
        }

        .moblie_pay_container_step_value_bn {
          font-size: 16px;
        }
      }
    }

    .moblie_pay_container_step_card {
      position: relative;

      &::before {
        position: absolute;
        top: 0;
        left: -8px;
        transform: translateX(-100%);
        content: "";
        background: url("~@/assets/1119/card.png") no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
      }
    }

    .moblie_pay_container_step_refresh {
      position: relative;

      &::before {
        position: absolute;
        top: 0;
        left: -8px;
        transform: translateX(-100%);
        content: "";
        background: url("~@/assets/1119/refresh.png") no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
      }
    }

    .moblie_pay_container_step_box_account {
      position: relative;

      &::before {
        position: absolute;
        top: 0;
        left: -8px;
        transform: translateX(-100%);
        content: "";
        background: url("~@/assets/1119/account.png") no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
      }
    }
    .moblie_pay_container_step_box_tipsContent {
      position: relative;

      &::before {
        position: absolute;
        top: 0;
        left: -8px;
        transform: translateX(-100%);
        content: "";
        background: url("~@/assets/1119/tipsContent.png") no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
      }
    }

    .moblie_pay_container_step_item_line {
      position: relative;

      &::after {
        position: absolute;
        top: -20px;
        left: -24px;
        transform: translateX(-100%);
        content: "";
        width: 1px;
        height: calc(100% + 32px);
        background: linear-gradient(
                to bottom,
                transparent 0%,
                transparent 50%,
                #99a1ab 50%,
                #99a1ab 100%
        );
        background-size: 1px 10px;
        background-repeat: repeat-y;
      }
    }


    .moblie_pay_container_dial {
      margin: 0 auto;
      //width: fit-content;
      margin-top: 10px;
      padding: 10px 20px;
      box-sizing: border-box;
      background: #e68608;
      border-radius: 20px;
      border: 1px solid #e68608;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;

      display: flex;
      align-items: center;
      justify-content: center;

    }

    .moblie_pay_container_dial_text {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 16px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #e68608;

      .moblie_pay_container_dial_text_img {
        width: 20px;
        height: 20px;
        margin-left: 6px;
      }
    }

    .moblie_pay_container_step_item_box {
      // margin: 0 20px;
      padding: 20px 15px;
      box-sizing: border-box;
      margin-top: 8px;

      background: #f5f5f5;
      border-radius: 8px;

      .moblie_pay_container_step_account_box {
        .moblie_pay_container_step_account_label {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #333333;
        }

        .moblie_pay_container_step_account_box_2 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 5px;
          margin-bottom: 5px;
          box-sizing: border-box;
          border-bottom: 1px solid #cccccc;

          .moblie_pay_container_step_account_label_2 {
            font-family: Helvetica, Helvetica;
            font-weight: bold;
            font-size: 20px;
            color: #cccccc;
          }

          .moblie_pay_container_step_account_label_3 {
            margin-top: 5px;
            display: flex;
            align-items: center;
            justify-content: center;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 12.5px;
            color: #ffffff;

            width: 80px;
            height: 22px;
            background: #e68608;
            border-radius: 15px;
            border: 1px solid #e68608;
          }

          .moblie_pay_container_step_account_label_4 {
            width: 22px;
            height: 22px;

          }
        }

        .moblie_pay_container_step_account_box_3 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 10px;
          color: #999999;
        }
      }

      .moblie_pay_container_step_account_box_4 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #e68608;
        margin-bottom: 2px;
        margin-top: 15px;
      }

      .moblie_pay_container_step_account_box_5 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 11px;
        color: #333333;
        margin-bottom: 5px;
      }

      .moblie_pay_container_step_account_box_6 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 11px;
        color: red;
      }

      &:has(.moblie_pay_container_step_transfer) {
        margin-bottom: 15px;
      }

      .moblie_pay_container_step_item {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }

        .moblie_pay_container_step_item_value {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: wrap;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #dc811d;

          span {
            font-size: 12px;
            margin-right: 4px;
          }

          .moblie_pay_container_step_item_value_2 {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-top: 4px;
            margin-bottom: 4px;

            .moblie_pay_container_step_item_value_2_info {
              width: 200px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 22px;
              color: #e68608;

              span {
                font-size: 14px;
              }
            }

            .moblie_pay_container_step_item_value_2_copy {
              display: flex;
              align-items: center;
              justify-content: center;

              //font-family: PingFangSC, PingFang SC;
              //font-weight: 500;
              //font-size: 13px;
              //color: #ffffff;
              //
              //width: 60px;
              //height: 22px;
              //background: #e68608;
              //border-radius: 15px;
              //border: 1px solid #e68608;
              width: 20px;
              height: 20px;
            }
          }

          .moblie_pay_container_step_item_value_label {
            width: 100%;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #888888;
          }

          .moblie_pay_container_step_item_value_va {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #dc811d;
          }
        }

        .moblie_pay_container_step_item_img {
          width: 50px;
          height: 18px;
          margin-left: 10px;
          cursor: pointer;
        }
      }

      .moblie_pay_container_step_transfer {
        .moblie_pay_container_step_item_value {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: wrap;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #555555;
          line-height: 18px;

          span {
            color: #dc811d;
            margin: 0 8px;
          }

          .moblie_pay_container_step_transfer_btn {
            cursor: pointer;
            padding: 3px 10px;
            box-sizing: border-box;
            background: rgba(220, 129, 29, 0.12);
            border-radius: 18px;
            margin-right: 8px;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 11px;
            color: #dc811d;

            display: flex;
            align-items: center;
            justify-content: center;

            .moblie_pay_container_step_transfer_btn_img {
              width: 11px;
              height: 11px;
              margin-right: 2px;
            }
          }

          .moblie_pay_container_step_item_value_width {
            width: 100%;
          }
        }
      }
    }


    .moblie_pay_container_step_sms_example {
      margin-top: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 11px;
      color: #555555;
    }

    .moblie_pay_container_step_sms_example_content {
      position: relative;
      margin-top: 4px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 11px;
      color: #333333;
      line-height: 16px;

      padding: 10px 12px;
      box-sizing: border-box;
      background: #f5f5f5;
      border: 1px solid #dddddd;
      border-radius: 8px;

      .moblie_pay_container_step_sms_example_content_copy {
        position: absolute;
        top: 30px;
        left: 27px;
        width: 36px;
        height: 26px;
        background: rgba(0, 0, 0, 0.55);
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;

        &:before {
          position: absolute;
          top: 0;
          transform: translateY(-100%);
          content: "";

          width: 0;
          height: 0;
          border-left: 6px solid transparent; /* 左边框 */
          border-right: 6px solid transparent; /* 右边框 */
          border-bottom: 6px solid rgba(0, 0, 0, 0.55); /* 底边框，颜色为蓝色 */
        }
      }

      span {
        color: #ffffff;
        background: #6e86a1;
      }
    }

    .moblie_pay_container_step_sms_example_desc {
      margin-top: 4px;
      margin-right: 4px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 10px;
      line-height: 12px;
      color: #555555;

      span {
        color: red;
      }
    }

    .moblie_pay_container_step_account {
      //margin: 0 20px;
      //margin-top: 10px;

      .moblie_pay_container_step_account_input_desc {
        margin-bottom: 6px;
        color: #e68608;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 11px;
        color: #888888;
      }

      .moblie_pay_container_step_account_input_box {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 6px;
        box-sizing: border-box;

        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #cccccc;

        .moblie_pay_container_step_233 {
          width: 40px;
          color: #dc811d;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
        }
      }

      .moblie_pay_container_step_account_input_box2 {
        height: 132px;
      }

      .moblie_pay_container_step_account_input_box_s {
        height: 40px;

        .moblie_pay_container_step_account_input {
          height: 100%;
          overflow-y: hidden;
          line-height: 40px;
          padding: 0;
        }
      }

      .moblie_pay_container_step_account_input {
        width: 100%;
        height: 100%;

        //height: 40px;
        border: none;
        //padding-left: 10px;
        box-sizing: border-box;

        outline: none;
        //margin-right: 20px;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #000000;

        &:focus {
          //border: 1px solid #DC811D;
        }

        &::placeholder {
          line-height: 18px;
          font-size: 11px;
          color: #b6b6b6;
        }
      }

      .moblie_pay_container_step_account_success {
        margin-right: 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 16px;
          height: 16px;
        }
      }

      .moblie_pay_container_step_account_submit_box {
        margin-top: 6px;
      }

      .moblie_pay_container_step_account_submit {
        width: 50px;
        padding: 4px 5px;
        box-sizing: border-box;
        background: #e68608;
        border-radius: 15px;
        border: 1px solid #e68608;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 11px;
        color: #ffffff;

        position: relative;

        display: flex;
        align-items: center;
        justify-content: center;

        .moblie_pay_container_step_account_submit_text {
          //position: absolute;
          //top: 50%;
          //left: 50%;
          //transform: translate(-50%, -50%);
          //z-index: 2;
        }

        .moblie_pay_container_step_account_submit_text_img {
          position: absolute;
          right: 7px;
          top: 50%;
          transform: translateY(-50%);
          width: 20px;
          height: 20px;
          z-index: 1;
        }

        .moblie_pay_container_step_account_submit_img {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(50%, -50%);
          width: 24px;
          height: 13px;
          z-index: 1;
        }
      }

      .moblie_pay_container_step_account_submit3 {
        margin: 0 auto;
        padding: 6px 18px;

        font-size: 16px;
        margin-top: 6px;

        width: 150px;
        height: 34px;
        background: #e68608;
        border-radius: 23px;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 13px;
        color: #ffffff;
      }

      .moblie_pay_container_step_account_submit2 {
        width: 240px;
      }
    }
  }

  .moblie_pay_container_result {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 12px 15px;
    //padding-left: 15px;
    margin-top: 16px;
    line-height: 17px;
    background: #f2f2f2;
    width: 100%;
    display: none;

    .moblie_pay_container_result_info {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #777777;

      span {
        margin-left: 6px;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #e68608;
      }

      .moblie_pay_container_result_info_amount {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
      }

      .moblie_pay_container_result_info_content {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 6px;
        padding-left: 26px;
      }

      .moblie_pay_container_result_info_btn {
        cursor: pointer;
        padding: 1px 4px;

        width: fit-content;
        box-sizing: border-box;

        margin-left: 8px;

        background: rgba(230, 134, 8, 0.08);
        border-radius: 15px;
        border: 1px solid #e68608;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 11px;
        color: #e68608;
      }
    }
  }

  .moblie_pay_container_result_submit {
    cursor: pointer;
    position: relative;
    position: relative;
    margin: 0 auto;
    margin-top: 15px;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #895c25;

    width: 260px;
    height: 45px;
    background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
    border-radius: 8px;

    display: flex;
    align-items: center;
    justify-content: center;

    display: none;

    .moblie_pay_container_result_submit_text {
      transform: translateX(16px);
    }

    .moblie_pay_container_result_submit_img {
      transform: translateX(8px) translateY(2px);

      width: 24px;
      height: 13px;
    }
  }

  .moblie_pay_container_tips {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    box-sizing: border-box;
    margin-top: 15px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 11px;
    color: #888888;
    padding: 0 20px;

    display: none;

    .moblie_pay_container_tips_img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }
}

.moblie_pay_payment_account_popup {
  .moblie_pay_payment_account_popup_main {
    position: relative;
    width: 345px;
    background: #ffffff;
    border-radius: 15px;
    overflow: hidden;

    .paymentMethod {
      .paymentMethod_title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 13px;
        color: #7F7870;
        margin-top: 25px;
        margin-left: 20px;
      }

      .paymentMethod_box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        margin-top: 15px;

        .paymentMethod_item {
          position: relative;
          width: 90px;
          height: 70px;
          background: #FFFFFF;
          box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          border: 1px solid #CCCCCC;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          margin: 0 6px;
          overflow: hidden;

          .paymentMethod_item_logo {
            width: 28px;
            height: 28px;
          }

          .paymentMethod_item_name {
            width: 100%;
            text-align: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #736B5A;
          }

          .paymentMethod_item_true {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 20px;
            height: 20px;
          }
        }

        .paymentMethod_item_s {
          background: rgba(246, 136, 52, 0.08);
          box-shadow: 0px 2px 10px 0px rgba(255, 112, 0, 0.2);
          border-radius: 8px;
          border: 1px solid #DBA95A;
        }
      }
    }

    .moblie_pay_payment_account_popup_main_close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
    }

    .moblie_pay_payment_account_popup_main_logo {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 30px;
      box-sizing: border-box;

      .moblie_pay_payment_account_popup_main_logo_img {
        height: 50px;
        border-radius: 8px;
      }
    }

    .moblie_pay_payment_account_popup_main_title {
      padding-top: 30px;
      margin-left: 20px;
      margin-right: 20px;
      margin-bottom: 6px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #555555;

      display: flex;
      align-items: center;
      justify-content: flex-start;

      .moblie_pay_payment_account_popup_main_title_img {
        width: 18px;
        height: 18px;
        margin-right: 8px;
      }
    }

    .moblie_pay_payment_account_popup_main_desc {
      margin-left: 20px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #7f7870;
      line-height: 17px;
    }

    .moblie_pay_payment_account_popup_main_detail_title {
      padding-top: 30px;
      margin-left: 20px;
      margin-bottom: 20px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #524535;
    }

    .moblie_pay_payment_account_popup_main_collect_box {
      margin-top: 20px;
      background: rgba(122, 122, 122, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 30px 12px;
      box-sizing: border-box;

      .moblie_pay_payment_account_popup_main_collect_num {
        width: 100%;
        text-align: left;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #7f7870;
      }

      .moblie_pay_payment_account_popup_main_collect_total {
        margin-top: 20px;
        width: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 13px;
        color: #776a5a;

        span {
          color: #dc811d;
          margin-left: 6px;
        }

        .moblie_pay_payment_account_popup_main_collect_total_amount {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
        }

        .moblie_pay_payment_account_popup_main_collect_total_detail {
          cursor: pointer;
          padding: 3px 10px;
          box-sizing: border-box;
          background: rgba(220, 129, 29, 0.12);
          border-radius: 18px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 11px;
          color: #dc811d;
          margin-left: 8px;
        }

        .moblie_pay_payment_account_popup_main_collect_total_edit {
          cursor: pointer;
          padding: 6px 10px;
          box-sizing: border-box;
          background: rgba(220, 129, 29, 0.12);
          border-radius: 18px;
          margin-left: 8px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 11px;
          color: #dc811d;

          display: flex;
          align-items: center;
          justify-content: center;

          .moblie_pay_payment_account_popup_main_collect_total_edit_img {
            width: 11px;
            height: 11px;
            margin-right: 2px;
          }
        }
      }
    }

    .moblie_pay_payment_account_popup_main_collect_confirm_box {
      background: rgba(122, 122, 122, 0.1);
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding: 15px 30px;
      box-sizing: border-box;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #7f7870;
      line-height: 17px;

      span {
        color: #dc811d;
        margin: 0 6px;
      }
    }

    .moblie_pay_payment_account_popup_main_cur_account {
      margin-left: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #7f7870;

      span {
        color: #dc811d;
        margin-left: 3px;
      }
    }

    .moblie_pay_payment_account_popup_main_wait_amount {
      margin-top: 20px;
      margin-left: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #555555;

      span {
        color: #dc811d;
        margin-left: 3px;
      }

      .moblie_pay_payment_account_popup_main_wait_amount_num {
        font-size: 16px;
      }
    }

    .moblie_pay_container_step_account {
      margin: 0 20px;
      margin-top: 20px;
      display: flex;
      align-items: center;

      .moblie_pay_container_step_account_input_box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 8px;
        border: 1px solid #aaaaaa;
        padding: 0 6px;
        box-sizing: border-box;
      }

      .moblie_pay_container_step_233 {
        width: 40px;
        color: #dc811d;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
      }

      .moblie_pay_container_step_account_input {
        width: 100%;

        height: 40px;
        border: none;
        //padding-left: 10px;
        box-sizing: border-box;

        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        outline: none;
        //margin-right: 20px;

        &:focus {
          //border: 1px solid #DC811D;
        }

        &::placeholder {
          color: #bbbbbb;
        }
      }
    }

    .moblie_pay_container_step_tips {
      margin-left: 30px;
      margin-top: 2px;
      font-size: 12px;

      span {
        color: red;
      }
    }

    .moblie_pay_container_step_pay_account {
      margin-top: 15px;
      padding: 10px 0;
      background: rgba(218, 91, 91, 0.1);
      padding-left: 20px;
      box-sizing: border-box;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;

      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 11px;
      color: #da5b5b;
      line-height: 16px;

      .moblie_pay_container_step_pay_account_img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }
    }

    .moblie_pay_container_step_account_submit {
      margin: 0 auto;
      margin-top: 15px;
      position: relative;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 15px;
      color: #ffffff;

      display: flex;
      align-items: center;
      justify-content: center;

      width: 168px;
      height: 45px;
      background: linear-gradient(
              180deg,
              #f6d07f 0%,
              #d78d2a 100%,
              #d47000 100%
      );
      border-radius: 23px;

      .moblie_pay_container_step_account_submit_text {
      }

      .moblie_pay_container_step_account_submit_img {
        width: 13px;
        height: 11px;
        margin-left: 6px;
      }
    }

    .moblie_pay_payment_account_popup_main_confirm_box {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .moblie_pay_payment_account_popup_close_box {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .moblie_pay_payment_account_popup_close {
      cursor: pointer;
      width: 30px;
      height: 30px;
    }
  }
}

.moblie_pay_payment_account_verify_popup {
  .moblie_pay_payment_account_verify_popup_main {
    width: 280px;
    background: #ffffff;
    border-radius: 15px;
    padding: 20px 42px;
    box-sizing: border-box;
    overflow: hidden;

    .moblie_pay_payment_account_verify_popup_main_title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 13px;
      color: #555555;
      margin-bottom: 15px;
    }

    .moblie_pay_payment_account_verify_popup_main_item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 8px;
      padding: 0 8px;
      box-sizing: border-box;

      .moblie_pay_payment_account_verify_popup_main_item_label {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 13px;
        color: #777777;
        margin-right: 5px;
      }

      .moblie_pay_payment_account_verify_popup_main_item_value {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 13px;
        color: #e68608;
      }
    }

    .moblie_pay_payment_account_verify_popup_main_btnBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;

      .moblie_pay_payment_account_verify_popup_main_btn {
        width: 90px;
        height: 35px;
        background: rgba(246, 136, 52, 0.08);
        box-shadow: 0px 2px 10px 0px rgba(255, 112, 0, 0.2);
        border-radius: 8px;
        border: 1px solid #dba95a;
        display: flex;
        align-items: center;
        justify-content: center;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #977d5d;

        box-sizing: border-box;
      }

      .moblie_pay_payment_account_verify_popup_main_btn2 {
        background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
        color: #895c25;
        border: none;
        box-shadow: none;
      }

      .moblie_pay_payment_account_verify_popup_main_btn2_ban {
        pointer-events: none;
        background: #e0e0e0;
        color: #666666;
      }
    }
  }
}

.data-box {
  width: 100%;

  .th-row {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
    box-sizing: border-box;
    background: rgba(122, 122, 122, 0.1);
    //border-radius: 15px 15px 0px 0px;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #524535;
  }

  .td-row {
    padding: 6px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #7f7870;
  }

  ::v-deep .van-col {
    flex: 1;
    text-align: center;
  }
}

// 超出 1 行显示省略号
.common-ellipsis {
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  word-wrap: break-word;
  word-break: break-all;
  padding: 2px;
  box-sizing: border-box;
  font-size: 10px;
}

// 滚动条位置 --展示的是竖向
// /deep/.__bar-is-vertical {
// right: -1px !important;
// }
// // 隐藏横向滚动条
// /deep/.__bar-is-horizontal {
// display: none !important;
// }

// 滚动条位置 --展示横向
:deep(.__bar-is-vertical) {
  display: none !important;
}

// 隐藏横向滚动条
:deep(.__bar-is-horizontal) {
  bottom: -1px !important;
}
</style>
<style lang="scss">
.moblie_pay_container_step_item_value_label_popover_text {
  width: 200px;
  padding: 8px;
}


.moblie_pay_container_step_item_value_label_icon {
  color: #dc811d;
}
</style>
